/**
 * src/utils/cupon.js — política única de códigos de cupón.
 *
 * Los códigos viven en MAYÚSCULAS en todos lados: se guardan upper(trim()) y se
 * comparan upper(trim()) (espejo de las RPCs validar_cupon / canjear_cupon /
 * admin_crear_cupon / certificar_pacto_nucleo). El usuario y el admin pueden
 * tipear como quieran. Sin límite de largo (el único piso es no-vacío, que
 * valida la UI y el CHECK char_length >= 1 de la DB).
 */

export const normalizarCodigoCupon = (valor) => String(valor ?? '').trim().toUpperCase();
